// extracted by mini-css-extract-plugin
export default {"container":"SPSelect_container__I5uYH","header":"SPSelect_header__7MruI","dropdown":"SPSelect_dropdown__A+8uY"};